import { useState,useEffect } from 'react'
import { useDispatch,useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { TagsInput } from "react-tag-input-component";
import { useJwt } from "../../../../helpers/common";
import  useOrganizationService from '../../../../services/organization';



const InviteTeam = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const JWTdata = useJwt();
    const [selected, setSelected] = useState([]);
    const { inviteUsers } = useOrganizationService();
    const {inviteUsersSuccess,inviteUsersLoading} = useSelector((state: any) => state.organization);
    
    const handleContinue = async() => {
        if(JWTdata.org_id && selected.length){
            if(!inviteUsersLoading){
                await inviteUsers(JWTdata.org_id,{email_list:selected})
            }
        } else {
            window.location.href= "/" 
        }
        
    }
    const handleSkip = () => {
        window.location.href= "/workitems"
    }

    useEffect(()=>{
        if(inviteUsersSuccess){
            setTimeout(()=>{
                window.location.href= "/workitems" 
            },300)
            
        }
    },[inviteUsersSuccess])


    return (
        <div tabIndex={-1} aria-hidden="true" className="relative p-4 w-full  h-[100vh] flex flex-col items-center justify-center">
                    <div className="text-center dark:text-white text-gray-700 text-3xl font-normal mb-2">Invite your co-workers</div>
                    <div className="opacity-50 text-center dark:text-white text-gray-700 text-lg font-light leading-relaxed">Cadence is more helpful when you work with your team members </div>
                    <div className="w-96 mt-8 dark:text-white text-gray-700 text-sm font-normal leading-tight">Email </div>
                    <div className="mt-4 text-center">
                        <div className="w-96 h-32">
                            <TagsInput
                                value={selected}
                                onChange={setSelected}
                                name="userEmails"
                                placeHolder="enter email"
                                classNames={{input:"w-full   dark:bg-slate-800 dark:text-white bg-slate-100 rounded-lg border dark:border-slate-700 border-slate-100"}}
                            />
                        </div>
                        
                    </div>
                    <div className="flex mt-12 w-96">
                        <div onClick={handleSkip} className="w-40 h-9 px-5 py-3 bg-gray-800 rounded-lg border border-gray-600 justify-center items-center gap-2 inline-flex cursor-pointer">
                            <div  className="text-gray-400 text-base font-medium leading-normal ">Skip</div>
                        </div>
                        <div onClick={handleContinue} className="w-52 h-9 ml-auto px-5 py-3 bg-blue-700 rounded-lg justify-center items-center gap-2 inline-flex cursor-pointer">
                            <div className="text-white text-base font-medium leading-normal">Next</div>
                        </div>
                    </div>
                
        </div>
    )
}

export default InviteTeam;
